// eslint-disable-next-line import/prefer-default-export
export const getWebpImg = (images, name) => ({
  src: images[`${name}.png`],
  srcWebp: images[`${name}.webp`],
  srcMobile: images[`${name}-mobile.png`],
  srcMobileWebp: images[`${name}-mobile.webp`]
});
